import { BarChart3, Target } from "lucide-react";
//import svgPaths from "../../imports/Icon/svg-sta87c9gdb";

export function ValuePreviewPanel() {
  return (
    <div className="space-y-4 lg:space-y-5">
      {/* Free value card */}
      <div className="rounded-2xl border border-[#B0DCE1] overflow-hidden" style={{ backgroundColor: 'rgba(230, 244, 245, 0.4)' }}>
        <div className="px-[20px] pt-[20px] pb-[1px]">
          {/* Header */}
          <div className="mb-5 lg:mb-6">
            <span className="inline-block text-[11px] font-bold uppercase tracking-[1.2px] text-[#008e9f] mb-2">Gratis</span>
            <h3 className="text-[17px] lg:text-[17px] font-bold text-[#1a1a1a] leading-snug">Det får du med det samme</h3>
          </div>

          {/* Value items */}
          <div className="space-y-4 lg:space-y-5 mb-5 lg:mb-6">
            <PreviewItem
              icon={Target}
              title="Din markedsposition"
              description="Se om din løn er over, under eller inden for markedet"
            />
            <PreviewItem
              icon={BarChart3}
              title="Typisk løninterval"
              description="Hvad profiler som din typisk tjener"
            />
          </div>

          {/* Divider - desktop only */}
          

          {/* Progress section - desktop only */}
          
        </div>
      </div>

      {/* Extended value teaser */}
      <div className="rounded-2xl border border-[#F3D2BE] overflow-hidden" style={{ backgroundColor: 'rgba(251, 241, 234, 0.4)' }}>
        <div className="px-5 py-5 lg:px-7 lg:py-6">
          {/* Header */}
          <div className="mb-4 lg:mb-5">
            <span className="inline-block text-[11px] font-bold uppercase tracking-[1.2px] text-[#d76f2c] mb-2">Adgang</span>
            <h3 className="text-[17px] lg:text-[17px] font-bold text-[#1a1a1a] leading-snug">Få adgang til din personlige lønside og</h3>
          </div>

          {/* Benefits list */}
          <div className="space-y-3 lg:space-y-3.5">
            <ExtendedItem title="Forstå, hvad din løn reelt dækker" />
            <ExtendedItem title="Se hvilke vilkår der typisk følger med dit lønniveau" />
            <ExtendedItem title="Få konkrete råd til din næste lønsamtale" />
            <ExtendedItem title="Se hvad du realistisk kan forvente – og hvornår det giver mening" />
          </div>
        </div>
      </div>
    </div>
  );
}

function PreviewItem({ icon: Icon, title, description }: {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
}) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-10 h-10 lg:w-9 lg:h-9 rounded-lg bg-[#e6f4f5] flex items-center justify-center shrink-0">
        <Icon className="w-5 h-5 lg:w-4.5 lg:h-4.5 text-[#008e9f]" />
      </div>
      <div className="flex-1">
        <div className="text-[15px] lg:text-[14px] font-bold text-[#1a1a1a] leading-snug mb-1">{title}</div>
        <div className="text-[14px] lg:text-[13px] text-[#6b7280] leading-relaxed">{description}</div>
      </div>
    </div>
  );
}

function ExtendedItem({ title }: {
  title: string;
}) {
  return (
    <div className="flex items-center gap-3">
      <div className="w-4 h-4 shrink-0">
        <svg className="w-full h-full" fill="none" viewBox="0 0 16 16">
          <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="#D76F2C" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33333" />
        </svg>
      </div>
      <span className="text-[14px] lg:text-[13px] font-medium text-[#1a1a1a]">{title}</span>
    </div>
  );
}
